import dialog from './dialog'

dialog.install = (Vue, options) => {
	Vue.prototype.$dialog = new (Vue.extend(dialog))({ propsData: options })
	Vue.dialog = Vue.prototype.$dialog
}

export default dialog



// WEBPACK FOOTER //
// ./src/components/ui/dialog/index.js